import React from 'react';
import {IconButton, makeStyles, Paper, Toolbar, Typography} from "@material-ui/core";
import {Close} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        backgroundColor: '#f44336'
    },
    title: {
        color: 'white',
        flexGrow: 1
    },
    clickableCell: {
        cursor: 'pointer',
    },
}));

interface ErrorCardProps
{
    message: string;
    onClose: () => void;
}

export default function ErrorCard(props: ErrorCardProps)
{
    const classes = useStyles();
    const { message, onClose } = props;
    
    return (
        <Paper className={classes.paper}>
            <Toolbar>
                <Typography className={classes.title} component="h2" variant="h5" gutterBottom>
                    Error
                </Typography>
                <IconButton size="small" color="default" onClick={onClose}>
                    <Close />
                </IconButton>
            </Toolbar>

            <Typography className={classes.title} component="h2" variant="body1">
                {message}
            </Typography>
        </Paper>
    )
}